import { useEffect } from "react";
import Pubsub from 'pubsub-js'
import {EVENT_FAVIRIATE_CHANGE, EVENT_NOTE_CHANGED} from "@/Const";

/** 触发事件 */
export function triggerEvent(name: string, data?: any) {
  document.body.dispatchEvent(
    new CustomEvent(name, {
      detail: data,
    })
  );
}

/** 监听事件 */
export function useEventListener(
  name: string,
  cb: (data: any) => void
): () => void {
  function removeListerner() {
    document.body.removeEventListener(name, cb);
  }
  useEffect(() => {
    document.body.addEventListener(name, cb);
    return removeListerner;
  }, []);
  return removeListerner;
}

/** 监听事件 */
export function addEventListener(
    name: string,
    func: (data: any) => void
) {
  document.body.removeEventListener(name, func);
  document.body.addEventListener(name, func);
}

/**
 * 取消监听....ALL
 */
export function unSubscribeAll(){
  Pubsub.unsubscribe(EVENT_NOTE_CHANGED);
  Pubsub.unsubscribe(EVENT_FAVIRIATE_CHANGE);
}

export function unSubscribe(szEventName:string){
  Pubsub.unsubscribe(szEventName);
}

/**
 * 发送消息 !!!!!!传递的对象不能有方法什么的乱七八遭的东西....
 * @param eventName
 * @param data
 */
export function postMessage(eventName:string,data:any=undefined){
  // window.postMessage({eventName:eventName,data:data});
  Pubsub.publish(eventName, {data:data});
}

export function recvMessage(eventName:string,callback:any,isAutoUnSubscribeBefore:boolean=false){
  if(isAutoUnSubscribeBefore){
    Pubsub.unsubscribe(eventName);
  }
  Pubsub.subscribe(eventName,callback);
}